//* Types imports
import type { MappingRule } from "@/features/techinicaldocument/types";

//* Hooks imports
import { usePhaseFormFieldKeys } from "@/hooks/phaseforms/querys/usePhaseForm-index";
import { useIndexProducts } from "@/hooks/products/querys/useIndexProducts";
import { useIndexPhaseFormsByProduct } from "@/hooks/phaseforms/querys/useIndexPhaseFormsByProduct";
import { useState, useEffect } from "react";

type RulesSectionProps = {
  selectedTag: string | null;
  replacements: Record<string, string>;
  onReplacementsChange: (replacements: Record<string, string>) => void;
  mappings?: Record<string, MappingRule>;
  onMappingsChange?: (mappings: Record<string, MappingRule>) => void;
  phaseFormId?: string;
  phaseForms?: any[];
  onPhaseFormChange?: (id: string) => void;
  loading?: boolean;
};

export const RulesSection = ({
  selectedTag,
  replacements,
  onReplacementsChange,
  mappings = {},
  onMappingsChange,
  phaseFormId,
  phaseForms = [],
  onPhaseFormChange,
  loading = false,
}: RulesSectionProps) => {
  const [selectedProductId, setSelectedProductId] = useState<string>("");

  const { data: products = [], isLoading: loadingProducts } = useIndexProducts();
  const { data: phaseFormsByProduct = [], isLoading: loadingPhaseForms } =
    useIndexPhaseFormsByProduct(selectedProductId);

  const { fieldKeys, fields } = usePhaseFormFieldKeys(
    selectedTag ? mappings[selectedTag]?.config?.phaseFormId : undefined
  );

  // Sincronizar selectedProductId se houver um formulário já selecionado no mapeamento
  useEffect(() => {
    if (selectedTag && mappings[selectedTag]?.type === "form") {
      const currentProductId = mappings[selectedTag]?.config?.productId;
      if (currentProductId) {
        setSelectedProductId(currentProductId);
      }
    }
  }, [selectedTag]);
  const handleValueChange = (value: string) => {
    if (selectedTag) {
      onReplacementsChange({
        ...replacements,
        [selectedTag]: value,
      });
      if (onMappingsChange) {
        onMappingsChange({
          ...mappings,
          [selectedTag]: { tag: selectedTag, type: "fixed", config: { value } },
        });
      }
    }
  };

  const rulesCount = Object.values(replacements).filter(
    (val) => val && val.trim() !== ""
  ).length;

  return (
    <div className="flex-1 w-full flex flex-col min-h-0">
      <section className="flex flex-col w-full h-full p-6 bg-white rounded-2xl border border-gray-200 overflow-hidden">
        <div className="flex flex-col w-full h-full overflow-hidden gap-5">
          <div className="flex items-center justify-center w-full">
            {/* <button className="flex justify-center items-center size-8 hover:bg-gray-100 rounded-lg transition-colors rotate-180">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/b541d552892f82d7b87dc1354fd02b53204096e5?placeholderIfAbsent=true"
                alt="Back"
                className="size-4 object-contain"
              />
            </button> */}
            <h2 className="text-2xl font-semibold text-center text-zinc-800">
              Regras
            </h2>
            {/* <button className="flex justify-center items-center bg-sky-600 rounded-lg size-8 hover:bg-sky-700 transition-colors">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/3c2f9bde013612f331a1ae0618c657307acc7135?placeholderIfAbsent=true"
                alt="Add"
                className="size-3 object-contain fill-white"
              />
            </button> */}
          </div>

          {/* <hr className="border-gray-200" /> */}

          <hr className="border-gray-200" />

          <div className="flex items-center justify-between w-full">
            <h3 className="text-base font-semibold text-slate-500">
              Regras Criadas ({rulesCount.toString().padStart(2, "0")})
            </h3>
            {/* <button className="flex justify-center items-center rounded-lg bg-gray-100 size-8 hover:bg-gray-200 transition-colors">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/a957b64922e04ac2a23d8b53cd42fbd2/8c1f99631846243fd937e1116c9f558f3d67ee56?placeholderIfAbsent=true"
                alt="Filter"
                className="size-2.5 object-contain fill-slate-500"
              />
            </button> */}
          </div>

          <hr className="border-gray-200" />

          <div className="overflow-y-auto flex-1 flex flex-col gap-5">
            <h3 className="w-full text-2xl font-semibold text-center text-zinc-800">
              Conteúdo {selectedTag ? `- ${selectedTag}` : ""}
            </h3>

            <hr className="border-gray-200" />

            <div className="w-full text-base text-gray-700">
              {selectedTag ? (
                <div className="flex flex-col gap-4 w-full">
                  <div className="flex flex-wrap gap-4 items-center w-full">
                    <label className="flex gap-2.5 items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors">
                      <span className="text-gray-700 font-medium">Valor</span>
                      <input
                        type="radio"
                        name="ruleType"
                        checked={
                          (mappings[selectedTag]?.type || "fixed") === "fixed"
                        }
                        onChange={() =>
                          onMappingsChange?.({
                            ...mappings,
                            [selectedTag]: {
                              tag: selectedTag,
                              type: "fixed",
                              config: {
                                value: replacements[selectedTag] || "",
                              },
                            },
                          })
                        }
                        className="w-5 h-5 rounded border border-gray-300 text-sky-600 focus:ring-sky-500"
                      />
                    </label>
                    <label className="flex gap-2.5 items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors">
                      <span className="text-gray-700 font-medium">Cliente</span>
                      <input
                        type="radio"
                        name="ruleType"
                        checked={mappings[selectedTag]?.type === "client"}
                        onChange={() =>
                          onMappingsChange?.({
                            ...mappings,
                            [selectedTag]: {
                              tag: selectedTag,
                              type: "client",
                              config: { field: "name" },
                            },
                          })
                        }
                        className="w-5 h-5 rounded border border-gray-300 text-sky-600 focus:ring-sky-500"
                      />
                    </label>
                    {
                      <label className="flex gap-2.5 items-center cursor-pointer hover:bg-gray-50 p-2 rounded-lg transition-colors">
                        <span className="text-gray-700 font-medium">
                          Formulário
                        </span>
                        <input
                          type="radio"
                          name="ruleType"
                          checked={mappings[selectedTag]?.type === "form"}
                          onChange={() =>
                            onMappingsChange?.({
                              ...mappings,
                              [selectedTag]: {
                                tag: selectedTag,
                                type: "form",
                                config: {
                                  fieldKey: fieldKeys[0] || "",
                                  fieldId: fields.find(
                                    (f) => f.name === fieldKeys[0]
                                  )?._id,
                                  productId: selectedProductId,
                                },
                              },
                            })
                          }
                          className="w-5 h-5 rounded border border-gray-300 text-sky-600 focus:ring-sky-500"
                        />
                      </label>
                    }
                  </div>

                  <div className="flex flex-col gap-2 mt-2">
                    {(!mappings[selectedTag] ||
                      mappings[selectedTag]?.type === "fixed") && (
                      <>
                        <label className="text-sm font-bold text-slate-500">
                          Valor de substituição
                        </label>
                        <textarea
                          rows={5}
                          className="w-full p-3 text-base text-gray-700 rounded-lg border border-gray-200 bg-white focus:outline-none focus:ring-2 focus:ring-sky-600 transition-all resize-none"
                          placeholder={`Digite o valor para substituir ${selectedTag}...`}
                          value={replacements[selectedTag] || ""}
                          onChange={(e) => handleValueChange(e.target.value)}
                        />
                      </>
                    )}

                    {mappings[selectedTag]?.type === "client" && (
                      <div className="flex flex-col gap-2">
                        <label className="text-sm font-bold text-slate-500">
                          Campo do Cliente
                        </label>
                        <select
                          title="Selecione o campo do cliente"
                          value={mappings[selectedTag]?.config?.field || "name"}
                          onChange={(e) =>
                            onMappingsChange?.({
                              ...mappings,
                              [selectedTag]: {
                                tag: selectedTag,
                                type: "client",
                                config: { field: e.target.value as any },
                              },
                            })
                          }
                          className="p-2 border rounded-lg bg-white w-full max-w-full"
                        >
                          <option value="name">Nome</option>
                          <option value="cpf">CPF</option>
                          <option value="email">E-mail</option>
                          <option value="whatsapp">Whatsapp</option>
                          <option value="full_address">
                            Endereço completo
                          </option>
                        </select>
                      </div>
                    )}

                    {mappings[selectedTag]?.type === "form" && (
                      <>
                        <div className="flex flex-col w-full gap-4">
                          <div className="flex flex-col w-full">
                            <label className="text-sm font-semibold text-gray-700 mb-2">
                              Produto
                            </label>
                            {loadingProducts ? (
                              <div className="flex items-center justify-center p-2 border rounded-lg bg-gray-50">
                                <div className="animate-spin rounded-full size-5 border-b-2 border-sky-600"></div>
                                <span className="ml-2 text-sm text-gray-500">
                                  Carregando produtos...
                                </span>
                              </div>
                            ) : (
                              <select
                                title="Selecione o produto"
                                value={selectedProductId}
                                onChange={(e) => {
                                  const newProductId = e.target.value;
                                  setSelectedProductId(newProductId);
                                  // Limpar o formulário selecionado se o produto mudar
                                  if (
                                    mappings[selectedTag]?.config?.productId !==
                                    newProductId
                                  ) {
                                    onMappingsChange?.({
                                      ...mappings,
                                      [selectedTag]: {
                                        ...mappings[selectedTag],
                                        config: {
                                          ...mappings[selectedTag].config,
                                          productId: newProductId,
                                          phaseFormId: "",
                                          fieldKey: "",
                                          fieldId: "",
                                        },
                                      },
                                    });
                                  }
                                }}
                                className="p-2 border rounded-lg bg-white w-full max-w-full"
                              >
                                <option value="">Selecione um produto</option>
                                {products.map((p) => (
                                  <option key={p._id} value={p._id}>
                                    {p.name}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>

                          <div className="flex flex-col w-full">
                            <label className="text-sm font-semibold text-gray-700 mb-2">
                              Formulário
                            </label>
                            {loadingPhaseForms ? (
                              <div className="flex items-center justify-center p-2 border rounded-lg bg-gray-50">
                                <div className="animate-spin rounded-full size-5 border-b-2 border-sky-600"></div>
                                <span className="ml-2 text-sm text-gray-500">
                                  Carregando formulários...
                                </span>
                              </div>
                            ) : (
                              <select
                                title="Selecione o formulário"
                                value={
                                  mappings[selectedTag]?.config?.phaseFormId ||
                                  ""
                                }
                                disabled={!selectedProductId}
                                onChange={(e) => {
                                  onMappingsChange?.({
                                    ...mappings,
                                    [selectedTag]: {
                                      tag: selectedTag,
                                      type: "form",
                                      config: {
                                        fieldKey: "",
                                        phaseFormId: e.target.value,
                                        productId: selectedProductId,
                                        fieldId: "",
                                      },
                                    },
                                  });
                                }}
                                className="p-2 border rounded-lg bg-white w-full max-w-full disabled:bg-gray-100 disabled:cursor-not-allowed"
                              >
                                <option value="">
                                  {!selectedProductId
                                    ? "Selecione primeiro um produto"
                                    : "Selecione um formulário"}
                                </option>
                                {phaseFormsByProduct.map((f) => (
                                  <option
                                    key={f._id}
                                    value={f._id}
                                    title={f.name || f._id}
                                  >
                                    {((f.name || f._id) ?? "").length > 50
                                      ? ((f.name || f._id) ?? "").substring(
                                          0,
                                          50
                                        ) + "..."
                                      : f.name || f._id}
                                  </option>
                                ))}
                              </select>
                            )}
                          </div>
                        </div>

                        {mappings[selectedTag]?.config?.phaseFormId && (
                          <div className="flex flex-col gap-2">
                            <label className="text-sm font-bold text-slate-500">
                              Campo do Formulário Base
                            </label>
                            <select
                              title="Selecione o campo do formulário base"
                              value={
                                mappings[selectedTag]?.config?.fieldKey || ""
                              }
                              onChange={(e) => {
                                const selectedKey = e.target.value;
                                const selectedField = fields.find(
                                  (f) => f.name === selectedKey
                                );

                                const isSelect =
                                  selectedField?.type === "SELECT";
                                const items = isSelect
                                  ? selectedField?.options?.map((opt) => ({
                                      key: opt.key || opt.value,
                                      value: "",
                                    }))
                                  : undefined;

                                onMappingsChange?.({
                                  ...mappings,
                                  [selectedTag]: {
                                    tag: selectedTag,
                                    type: "form",
                                    config: {
                                      phaseFormId:
                                        mappings[selectedTag]?.config
                                          ?.phaseFormId,
                                      productId: selectedProductId,
                                      fieldKey: selectedKey,
                                      fieldId: selectedField?._id,
                                      fieldType: selectedField?.type,
                                      label: selectedField?.name,
                                      items: items,
                                    },
                                  },
                                });
                              }}
                              className="p-2 border rounded-lg bg-white w-full max-w-full"
                            >
                              <option value="">Selecione</option>
                              {fieldKeys.map((k,index_) => (
                                <option key={k} value={k} title={k}>
                                 {index_+1}) {k.length > 50
                                    ? k.substring(0, 50) + "..."
                                    : k}
                                </option>
                              ))}
                            </select>

                            {(() => {
                              const activeFieldKey =
                                mappings[selectedTag]?.config?.fieldKey;
                              const activeField = fields.find(
                                (f) => f.name === activeFieldKey
                              );
                              const isSelectType =
                                activeField?.type === "SELECT";

                              if (isSelectType && activeField?.options) {
                                return (
                                  <div className="flex flex-col gap-2 mt-2 p-3 bg-gray-50 rounded-lg border border-gray-100">
                                    <label className="text-sm font-bold text-slate-500">
                                      Mapeamento de Opções
                                    </label>
                                    <div className="flex flex-col gap-3">
                                      {activeField.options.map((opt, index) => {
                                        const key = opt.key || opt.value;
                                        const currentItem = mappings[
                                          selectedTag
                                        ]?.config?.items?.find(
                                          (i) => i.key === key
                                        );

                                        return (
                                          <div
                                            key={index}
                                            className="flex flex-col gap-1"
                                          >
                                            <span className="text-xs font-semibold text-gray-600">
                                              Quando selecionar: "{key}"
                                            </span>
                                            <input
                                              type="text"
                                              className="p-2 border rounded-lg text-sm bg-white focus:ring-2 focus:ring-sky-600 outline-none transition-all"
                                              placeholder={`Substituir por...`}
                                              value={currentItem?.value || ""}
                                              onChange={(e) => {
                                                const newValue = e.target.value;
                                                const currentItems =
                                                  mappings[selectedTag]?.config
                                                    ?.items || [];
                                                const itemIndex =
                                                  currentItems.findIndex(
                                                    (i) => i.key === key
                                                  );

                                                let newItems;
                                                if (itemIndex >= 0) {
                                                  newItems = [...currentItems];
                                                  newItems[itemIndex] = {
                                                    ...newItems[itemIndex],
                                                    value: newValue,
                                                  };
                                                } else {
                                                  newItems = [
                                                    ...currentItems,
                                                    {
                                                      key: key,
                                                      value: newValue,
                                                    },
                                                  ];
                                                }

                                                onMappingsChange?.({
                                                  ...mappings,
                                                  [selectedTag]: {
                                                    ...mappings[selectedTag],
                                                    config: {
                                                      ...mappings[selectedTag]
                                                        .config,
                                                      productId:
                                                        selectedProductId,
                                                      items: newItems,
                                                    },
                                                  },
                                                });
                                              }}
                                            />
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
                                );
                              }
                              return null;
                            })()}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center h-40 text-gray-400 text-center">
                  <p>
                    Selecione um campo na lista ao lado para definir suas regras
                    de preenchimento.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
